import { render, staticRenderFns } from "./TranferPallet.vue?vue&type=template&id=9feb3430"
import script from "./TranferPallet.vue?vue&type=script&lang=js"
export * from "./TranferPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports